import { render, staticRenderFns } from "./SecurityInvite.vue?vue&type=template&id=3d8b6202&scoped=true"
import script from "./SecurityInvite.vue?vue&type=script&lang=js"
export * from "./SecurityInvite.vue?vue&type=script&lang=js"
import style0 from "./SecurityInvite.vue?vue&type=style&index=0&id=3d8b6202&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8b6202",
  null
  
)

export default component.exports